import { gqlClient } from '@/api/graphql-client';
import applianceKeys from '@/api/queries/appliances/keyFactory';
import { graphql } from '@/gql';
import { ProductSpecCategory } from '@/gql/graphql';
import { useQuery } from '@tanstack/react-query';

const SearchAppliancesQuery = graphql(`
  query SearchAppliances($category: ProductSpecCategory, $searchTerm: String) {
    appliances(
      category: $category
      searchTerm: $searchTerm
      pagination: { limit: 100, offset: 0 }
    ) {
      items {
        id
        items {
          id
        }
        totalPrice {
          value
          currency {
            code
            exponent
          }
        }
        productSpec {
          id
          name
          category
          image {
            url
          }
          nominalOutputKw
          soundPowerDbA
          type
          domesticHotWaterLitres
        }
      }
    }
  }
`);

const useSearchAppliances = (
  category: ProductSpecCategory,
  searchTerm?: string
) => {
  const { data, ...rest } = useQuery({
    queryKey: applianceKeys.appliances(category, searchTerm),
    queryFn: () =>
      gqlClient.request(SearchAppliancesQuery, {
        category,
        searchTerm: searchTerm || undefined,
      }),
    enabled: !!searchTerm,
  });

  return { data: data?.appliances?.items, ...rest };
};

export default useSearchAppliances;
